import { configureStore } from "@reduxjs/toolkit";
import themeSettingSlice from "./themeSettingSlice";
import sidebarSlice from "./sidebarSlice";
import userSlice from "./slice/user";
import systemsSlice from "../redux/slice/systemsSlice";
import sessionsSlice from "../redux/slice/sessionsSlice";
import branchesSlice from "../redux/slice/branchesSlice";

const store = configureStore({
  reducer: {
    themeSetting: themeSettingSlice,
    sidebarSlice: sidebarSlice,
    user: userSlice,
    systems: systemsSlice,
    sessions: sessionsSlice,
    branches: branchesSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
